
export type GetHashtagsSort = typeof GetHashtagsSort[keyof typeof GetHashtagsSort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetHashtagsSort = {
  POPULAR: 'POPULAR',
  RECENT: 'RECENT',
} as const;
